import { masker } from './masker';

const numberMask = masker({
  masked: {
    mask: Number,
  },
  transform: (value: unknown) => {
    if (!value) {
      return null;
    }
    if (typeof value === 'number') {
      return value;
    }
    return Number(value);
  },
  maskDefault: (value: unknown) => {
    return numberMask.transform(value);
  },
});

export { numberMask };
